import { Component } from 'react'
import { Button } from 'components'

class AppErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Unhandled app error:', error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            padding: '24px',
            textAlign: 'center'
          }}
        >
          <h2 style={{ margin: 0 }}>Something went wrong</h2>
          <p style={{ margin: 0 }}>
            Please reload the page and try again.
          </p>
          <Button
            text="Reload"
            variant="contained"
            onClick={this.handleReload}
            width="120px"
            color="white"
            font_weight={600}
          />
        </div>
      )
    }

    return this.props.children
  }
}

export default AppErrorBoundary
